module.exports = __webpack_public_path__ + "static/media/printed_menu.b15eee11.jpg";